import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';

export const InstallmentPossibleSection = () => {
  return (
    <Container>
      <Wrapper>
        <IconTitleContainer>
          <Icon name={'CircleWon'} size={'Large'} fill={'#445EFF'} />
          <TitleContainer>
            <BoldTitle>{'할부가 가능한 매물'}</BoldTitle>
            <Title>{'이예요!'}</Title>
          </TitleContainer>
        </IconTitleContainer>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  align-items: center;
  gap: var(--radius-small, 4px);
  align-self: stretch;

  border-radius: var(--radius-none, 0px);
  background: var(--Light-Scheme-Color-secondary-blue, #e5e9ff);
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
`;

const IconTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--radius-small, 4px);
`;

const TitleContainer = styled.div``;

const Title = styled.span`
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: var(--Light-Scheme-Color-primary-blue, #445eff);
  text-overflow: ellipsis;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`;

const BoldTitle = styled(Title)`
  font-weight: 700;
`;
